import { render, staticRenderFns } from "./CategoryHome.vue?vue&type=template&id=793455d2&"
import script from "./CategoryHome.vue?vue&type=script&lang=js&"
export * from "./CategoryHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports